module.exports = __webpack_public_path__ + "img/calendarImg1.8458551a.png";